import React from 'react';

import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';


function WidgetSelect({ state, setState, id, text, value = "", options = {}, readOnly = false, multiple = false }) {
  React.useEffect(() => {
    setState({
      id: id,
      value: (multiple && value === "") ? [] : value,
      error: false,
      errorMessage: null,
    });
  }, []);

  const handleChange = (e) => {
    setState((s) => ({ ...s, value: e.target.value, error: false }));
  };


  return (
    <>
      {state !== null &&
        <FormControl error={state.error} className='w-full'>
          <InputLabel htmlFor={state.id}>{text}</InputLabel>
          <Select
            className='shadow-md shadow-gray-300'
            id={state.id}
            name={state.id}
            label={text}
            multiple={multiple}
            displayEmpty={multiple}
            MenuProps={{ PaperProps: { style: { maxHeight: 250, width: 250 } } }}
            readOnly={readOnly}

            value={state.value}
            onChange={handleChange}
          >
            {Object.keys(options).map(key => <MenuItem key={key} value={key}>{options[key]}</MenuItem>)}
          </Select>
          <FormHelperText>
            {state.error && state.errorMessage}
          </FormHelperText>
        </FormControl>
      }
    </>
  );
}

export default React.memo(WidgetSelect);